<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Pagination</strong>
        <small>size</small>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/pagination"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </c-card-header>
      <c-card-body>
        <h6>Default</h6>
        <c-pagination :active-page.sync="currentPage" :pages="10" responsive />
        <br />

        <h6>Small</h6>
        <c-pagination size="sm" :active-page.sync="currentPage" :pages="10" />
        <br />

        <div class="d-md-down-none">
          <h6>Large</h6>
          <c-pagination size="lg" :active-page.sync="currentPage" :pages="10" responsive />
          <br />
        </div>

        <div>currentPage: {{ currentPage }}</div>
      </c-card-body>
    </c-card>
    <c-card>
      <c-card-header>
        <c-icon name="cil-justify-center" />
        <strong>Pagination</strong>
        <small>alignment</small>
      </c-card-header>
      <c-card-body>
        <h6>Left alignment (default)</h6>
        <c-pagination :active-page.sync="currentPage" :pages="10" />
        <br />

        <h6>Center alignment</h6>
        <c-pagination align="center" :pages="10" :active-page.sync="currentPage" />
        <br />

        <h6>Right (end) alignment</h6>
        <c-pagination align="end" :active-page.sync="currentPage" :pages="10" />
        <br />

        <div>currentPage: {{ currentPage }}</div>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
export default {
  name: 'Paginations',
  data() {
    return {
      currentPage: 3,
    };
  },
};
</script>
